import { render, staticRenderFns } from "./lrDrawer.vue?vue&type=template&id=8508cafc"
import script from "./lrDrawer.vue?vue&type=script&lang=js"
export * from "./lrDrawer.vue?vue&type=script&lang=js"
import style0 from "./lrDrawer.vue?vue&type=style&index=0&id=8508cafc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports